import Cookies from 'js-cookie';

// Single source of truth for auth token persistence.
//
// Historically the accessToken/refreshToken cookies were read and written
// directly (via js-cookie) in several places — userSlice's thunks, the
// axios interceptor, the login flow — each repeating the same cookie names
// and options. This module centralises that so the names ('accessToken',
// 'refreshToken') and options ({ path: '/', expires: 7 }) live in one spot.
//
// Behaviour is intentionally identical to the previous inline calls
// (userSlice.tsx:71-78, api.ts:116-119): 7-day expiry, root path.

const ACCESS_TOKEN_COOKIE = 'accessToken';
const REFRESH_TOKEN_COOKIE = 'refreshToken';

const COOKIE_OPTIONS: Cookies.CookieAttributes = {
    path: '/',
    expires: 7, // Expires in 7 days
};

export function getAccessToken(): string | undefined {
    return Cookies.get(ACCESS_TOKEN_COOKIE);
}

export function getRefreshToken(): string | undefined {
    return Cookies.get(REFRESH_TOKEN_COOKIE);
}

export function setAccessToken(accessToken: string): void {
    Cookies.set(ACCESS_TOKEN_COOKIE, accessToken, COOKIE_OPTIONS);
}

export function setTokens({accessToken, refreshToken}: { accessToken: string; refreshToken: string }): void {
    setAccessToken(accessToken);
    Cookies.set(REFRESH_TOKEN_COOKIE, refreshToken, COOKIE_OPTIONS);
}

export function clearTokens(): void {
    Cookies.remove(ACCESS_TOKEN_COOKIE);
    Cookies.remove(REFRESH_TOKEN_COOKIE);
}
